import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface DriveShaftProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function DriveShaft(props: DriveShaftProps) {
  return (
    <svg
      width="560"
      height="46"
      viewBox="0 0 560 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 229, left: 463}}
      onClick={props.onClick}
    >
      <path
        d="M559 44C551.217 41.0393 537.191 37 525 37H519C517 37 517 35 517 35H511C511 35 511 37 509 37C507 37 507 35 507 35H503C501 35 501 33 501 33V31C501 31 501 33 499 33C497 33 497 31 497 31V29C497 29 497 31 495 31C493 31 493 29 493 29V27H485C485 27 480 31 477 31H308C307.44 31 306.934 30.7693 306.571 30.3984C304.484 33.1987 301.243 35 297.6 35H293V29H289V33C289 34.9922 287.016 35 287 35H285C285 35 283.123 35 283.006 33.1816L283 33H281C281 33 279 32.9999 279 31V29H271C271 29 271 31 269 31H47C45 31 41.3999 28.9301 37 26V27H29V29C28.9999 31 27 31 27 31H25C24.9999 33 23 33 23 33H19C18.9999 35 17 35 17 35H11C11 35 8.99991 34.9999 9 33V31C7.30558 30.9722 5.39984 29.93 1 27V19C4.4508 16.3482 6.32863 15.0489 9 15V13C8.99991 11.0001 11 11 11 11H17C17 11 18.9999 11.0001 19 13H23C23 13 24.9999 13.0001 25 15H27C27 15 28.9999 15.0001 29 17V19H37C40.4508 16.3482 44 15 47 15H269C271 15 271 17 271 17H279V15C279 13.0001 281 13 281 13H283C283 11.0001 285 11 285 11H287C287.016 11 289 11.0078 289 13V17H293V11H297.6C301.243 11 304.484 12.8007 306.571 15.6006C306.934 15.23 307.44 15 308 15H477C480.991 14.9999 484.982 18.982 485 19H493V17C493 17 493 15 495 15C497 15 497 17 497 17V15C497 15 497 13 499 13C501 13 501 15 501 15V13C501 13 501 11 503 11H507C507 11 507 9 509 9C511 9.00001 511 11 511 11H517C517 10.9748 517.013 9 519 9H525C537.191 9 551.217 4.96069 559 2V44Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M525 37.0004H519C517 37.0004 517 35.0004 517 35.0004V23.0002V11.0002C517 11.0002 517 9.00024 519 9.00024H525C537.191 9.00024 551.217 4.96069 559 2V44C551.217 41.0393 537.191 37.0004 525 37.0004Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M525 9.00012V37.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M306 15.0001H477V31.0001H306"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M485 27.0001C485 27.0001 480 31.0001 477 31.0001V15.0001C481 15 485 19.0001 485 19.0001V27.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M47 15H269C271 15 271 17 271 17V29C271 29 271 31 269 31H47V15Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M37 26C41.3999 28.9301 45 31 47 31V15C44 15 40.4508 16.3482 37 19V26Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1.00009 27.0001C5.40002 29.9302 7.30565 30.9723 9.00009 31.0001V15.0001C6.32867 15.049 4.45093 16.3483 1.00009 19.0001V27.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M485 19H493V27H485V19Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M29.0001 19.0001H37.0001V27.0001H29.0001V19.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="297"
        cy="23.0001"
        r="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M297 29.0001C300.314 29.0001 303 26.3138 303 23.0001C303 19.6864 300.314 17.0001 297 17.0001H289V29.0001H297Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M293 17.0001V11.0001H297.6C303.896 11.0001 309 16.3727 309 23.0001C309 29.6275 303.896 35.0001 297.6 35.0001H293V29.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M267 15.0001V31.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M279 17.0001L271 17V29.0001H279V17.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M9.00009 33.0001V23V13C9 11.0001 11 11.0001 11 11.0001H17C17 11.0001 19 11 19.0001 13V23V33.0001C19 35.0001 17 35 17 35H11C11 35 9 35 9.00009 33.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M283 33.0001V23V13C283 11.0001 285 11.0001 285 11.0001H287C287 11.0001 289 11 289 13V23V33.0001C289 35.0001 287 35 287 35H285C285 35 283 35 283 33.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M279 31.0001V23V15C279 13.0001 281 13.0001 281 13.0001H283V33H281C281 33 279 33 279 31.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M23 33H19V13.0001H23C23 13.0001 25 13 25.0001 15V23V31.0001C25 33.0001 23 33 23 33Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M27 31H25V15.0001H27C27 15.0001 29 15 29.0001 17V23V29.0001C29 31.0001 27 31 27 31Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M14.0001 11.0001V35.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M493 29L493 25L493 17C493 17 493 15 495 15C497 15 497 17 497 17L497 25L497 29C497 29 497 31 495 31C493 31 493 29 493 29Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M497 31L497 23L497 15C497 15 497 13 499 13C501 13 501 15 501 15L501 23L501 31C501 31 501 33 499 33C497 33 497 31 497 31Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M501 33L501 23L501 13C501 13 501 11 503 11L507 11L507 35L503 35C501 35 501 33 501 33Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M511 35L511 23L511 11C511 11 511 9 509 9C507 9 507 11 507 11L507 23L507 35C507 35 507 37 509 37C511 37 511 35 511 35Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        x="511"
        y="11"
        width="6"
        height="24"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
